<template>

  <div class="flex w-full h-screen bg-gray-50">
    <div class="flex-1 w-full overflow-y-auto">
        <Topbar />
        
        <div class="p-8" style="margin-top:64px;">
          <div class="flex justify-center items-center mb-6 relative">
              <div class="absolute left-0">
                  <RouterLink to="/employee" class="flex-none text-red-500 rounded-xl hover:text-red-700 cursor-pointer"> Назад </RouterLink>
              </div>
              <h2 class="text-2xl font-bold flex items-center gap-2">
                  <i class="pi pi-users" style="font-size: 2rem"></i>  Отчет оплаты труда
              </h2>
          </div>
      
          <ConfirmPopup />
          <Toast />
          <div class="card">
              <DataTable 
                  editMode="row" dataKey="id" :value="remunerationData" :paginator="true" :loading="loading" :rows="10" :rowsPerPageOptions="[5, 10]"
                  ref="workSchedulePlanTable" size="small" resizableColumns  columnResizeMode="fit"  showGridlines scrollable
                  :filters="filters" filterDisplay="menu" :globalFilterFields="['name', 'position']"
              >   
                  <template #empty> Нету данных за выбранный месяц </template>
                  <template #header>
                      <div class="flex justify-between">
                          <div class="flex flex-wrap gap-2 items-center justify-between">
                              <IconField>
                                  <InputIcon> <i class="pi pi-search" /> </InputIcon>
                                  <InputText v-model="filters['global'].value" placeholder="Поиск..." class="h-11"/>
                              </IconField>
                              <FloatLabel variant="on">
                                  <label for="on_label" class="z-10"> Месяц </label>
                                  <DatePicker v-model="selectedMonth" :invalid="!selectedMonth" view="month" size="small" dateFormat="yy-mm" inputId="on_label" showIcon iconDisplay="input" />
                              </FloatLabel>
                              <FloatLabel variant="on">
                                  <label for="on_label" class="z-10">Период оплаты</label>
                                  <Select id="currency" class="w-50 h-11 items-center" v-model="selectedPaymentPeriod" :options="paymentPeriods" :invalid="!selectedPaymentPeriod" optionLabel="name" optionValue="id" required></Select>
                              </FloatLabel>
                          </div>
                          <div class="flex">
                              <Button icon="pi pi-upload" severity="info" @click="exportCSV($event)" />
                          </div>
                      </div>
                  </template>
              
                  <Column field="employee.name"     header="ФИО" class="text-sm z-10" style="min-width: 8rem" frozen/>
                  <Column field="employee.position" header="Должность" class="text-sm" style="min-width: 8rem"/>
                  <!-- <Column field="employee.tariff" header="Тариф" class="text-center text-sm" style="min-width: 6rem">
                      <template #body={data}>
                          <div class="flex flex-col items-center">
                              {{ data.tariff.toLocaleString() + " KZT"}}
                          </div>
                      </template>
                  </Column> -->
                  <Column field="plan"       header="План" class="text-sm" style="min-width: 8rem"/>
                  <Column field="fact"       header="Факт" class="text-sm" style="min-width: 8rem"/>
                  <Column field="paid"       header="Оплачено" class="text-sm" style="min-width: 8rem"/>
                  <Column field="prepayment" header="Аванс" class="text-sm" style="min-width: 8rem"/>
                  <!-- <Column
                    v-for="col in columns"
                    :key="col.field"
                    :field="col.field"
                  >
                      <template #header>
                          <div class="flex flex-col items-center">
                              <span class="text-sm">{{ col.weekday }}</span>
                              <span class="text-xs font-bold">{{ col.header }}</span>
                          </div>
                      </template>
                      <template #body="{ data, field }">
                          <div class="flex flex-col items-center">
                              <Button :icon="data[field] === 1 ? 'pi pi-briefcase' : 'pi pi-times'" 
                                      :severity="data[field] === 1 ? 'info' : 'secondary'" disabled/>
                          </div>
                      </template>
                      <template #editor="{ data, field }">
                          <div class="flex flex-col items-center">
                              <Button :icon="data[field] === 1 ? 'pi pi-check' : 'pi pi-building'"
                                      :severity="data[field] === 1 ? 'success' : 'secondary'"
                                      @click="data[field] = data[field] === 1 ? 0 : 1"
                              />
                          </div>
                      </template>
                  </Column> -->
                  <!-- <Column field="total_days" header="Итого смен" class="text-center text-sm" style="min-width: 6rem" alignFrozen="right" frozen>
                      <template #body={data}>
                          <div class="flex flex-col items-center">
                              {{ data.total_days }}
                          </div>
                      </template>
                  </Column>
                  <Column field="total_sum"  header="План ФОТ" class="text-center text-sm" style="min-width: 6rem" alignFrozen="right" frozen>
                      <template #body={data}>
                          <div class="flex flex-col items-center">
                              {{ data.total_sum.toLocaleString() + " " + data.currency }}
                          </div>
                      </template>
                  </Column> -->
                  <!-- <ColumnGroup type="footer" v-if="workSchedulePlan.length > 0">
                      <Row>
                          <Column footer="Итого:" frozen/><Column/><Column/><Column/>
                          <Column footerStyle="text-align:center"
                              v-for="(value, day) in totalPerDay"
                                  :key="day"
                                  :footer="value ? value: 0"
                                  :class=totalChangeClass(value)
                          >
                          </Column>
                          <Column alignFrozen="right" :footer="totalDays" footerStyle="text-align:center" frozen/>
                          <Column alignFrozen="right" :footer="totalSum.toLocaleString()"  footerStyle="text-align:center" frozen/>
                          <Column alignFrozen="right" frozen/>
                      </Row>
                  </ColumnGroup> -->
              </DataTable>
          </div>
        </div>
        </div>  
    </div>
</template>

<script setup>
import axios from '../lib/axios'
import { ref, onMounted, watch, computed } from 'vue'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import { useToast } from 'primevue/usetoast'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import dayjs from 'dayjs'

const toast = useToast()
const loading = ref(false)
const router = useRouter()

const selectedMonth = ref(dayjs().format('YYYY-MM'))
const remunerationData = ref([])
const selectedPaymentPeriod = ref('1')
const paymentPeriods = ref([
    {
        'id': '1',
        'name': '1 пол месяца'
    },
    {
        'id': '2',
        'name': '2 пол месяца'
    }
])
const columns = ref([])
const totalPerDay = ref()
const totalDays = ref()
const totalSum = ref()

const filters = ref({
    'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
})

const initFilters = () => {
    filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    }
}
initFilters()

const clearFilter = () => {
    initFilters()
}

const month = computed(() => {
    return dayjs(selectedMonth.value).format('YYYY-MM')
})

watch(selectedMonth, (newValue, oldValue) => {
    fetchRemuneration()
    return dayjs(newValue).format('YYYY-MM')
})

// get data
const fetchRemuneration = () => {
    loading.value = true
    axios.get('/api/get-remuneration?date=' + month.value + '-01&period=' + selectedPaymentPeriod.value)
        .then(response => {
            remunerationData.value = response.data;
            loading.value = false
        })
        .catch(error => {
            toast.add({severity:'error', summary: 'Ошибка!', detail: error, life: 3000})
        });
};

const totalChangeClass = (value) => {
    if (value > 0) return 'text-success'
    return 'text-danger'
}

const exportCSV = () => {
    workSchedulePlanTable.value.exportCSV({ selectionOnly: false});
}

onMounted(() => {
    fetchRemuneration()
})
</script>

<style>
.text-success {
    color: green !important;
}
.text-danger {
    background-color: red !important;
    color: red;
}
</style>